import { render, staticRenderFns } from "./addAppointment.vue?vue&type=template&id=edb13d3e&scoped=true&"
import script from "./addAppointment.vue?vue&type=script&lang=js&"
export * from "./addAppointment.vue?vue&type=script&lang=js&"
import style0 from "./addAppointment.vue?vue&type=style&index=0&id=edb13d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb13d3e",
  null
  
)

export default component.exports